import { render, staticRenderFns } from "./CardEditDialog.vue?vue&type=template&id=e887a070&scoped=true"
import script from "./CardEditDialog.vue?vue&type=script&lang=js"
export * from "./CardEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e887a070",
  null
  
)

export default component.exports